import React from 'react';
import { Container, Logo, StyledButton, Subtitle, Title } from './WelcomePage.styles';
import { ContentSafeAreaView } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthActionsPending, selectStartParams } from '../../store/slices/auth/slice';
import { getUserInfo } from '../../store/slices/auth/asyncThunks';
import glassLogo from '../../assets/images/glass-logo.png';

const WelcomePage = () => {
  const dispatch = useDispatch();
  const { getUserInfo: getUserInfoPending } = useSelector(selectAuthActionsPending);
  const { affiliateId, influencerId } = useSelector(selectStartParams);

  const onRetry = () => {
    dispatch(getUserInfo({ ...(affiliateId && !influencerId && { affiliateId }) }))
      .unwrap()
      .then()
      .catch(() => {});
  };

  return (
    <ContentSafeAreaView>
      <Container>
        <Logo src={glassLogo} />
        <Title>Something went wrong</Title>
        <Subtitle>Please try again in a moment.</Subtitle>
        <StyledButton title="Try Again" isLoading={getUserInfoPending} onClick={onRetry} />
      </Container>
    </ContentSafeAreaView>
  );
};

export default WelcomePage;
